/** Reine Logik der Branchenauswahl in Schritt 2 (Autocomplete mit Chips wie bei LinkedIn). */

import { WIZARD_INDUSTRIES } from '../../industries';

/** Höchstzahl gewählter Branchen (wie im Backend). */
export const MAX_INDUSTRIES = 10;
/** Höchstzahl angezeigter Vorschläge. */
export const MAX_SUGGESTIONS = 50;

const fold = (text: string): string =>
  text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/ß/g, 'ss');

/**
 * Vorschläge zur Eingabe: Teiltreffer ohne Beachtung von Groß-/Kleinschreibung und Umlauten („ol“ findet Erdöl),
 * Anfang des Namens bzw. eines Wortes zuerst; bereits gewählte Branchen fehlen.
 */
export const industrySuggestions = (
  query: string,
  selected: string[],
  options: readonly string[] = WIZARD_INDUSTRIES,
  limit = MAX_SUGGESTIONS
): string[] => {
  const q = fold(query.trim());
  const chosen = new Set(selected);
  const rest = options.filter(o => !chosen.has(o));
  if (!q) return rest.slice(0, limit);
  const scored: Array<{ label: string; rank: number }> = [];
  for (const label of rest) {
    const f = fold(label);
    const at = f.indexOf(q);
    if (at < 0) continue;
    const wordStart = at === 0 || /[\s\-:,/&]/.test(f[at - 1]);
    scored.push({ label, rank: at === 0 ? 0 : wordStart ? 1 : 2 });
  }
  return scored
    .sort((a, b) => a.rank - b.rank)
    .slice(0, limit)
    .map(s => s.label);
};

/** Nimmt eine Auswahl an: nur Werte aus der Liste, ohne Duplikate, höchstens `MAX_INDUSTRIES`. */
export const sanitizeIndustries = (
  values: string[],
  options: readonly string[] = WIZARD_INDUSTRIES
): string[] => {
  const known = new Set(options);
  const out: string[] = [];
  for (const v of values) if (known.has(v) && !out.includes(v)) out.push(v);
  return out.slice(0, MAX_INDUSTRIES);
};
